import { render, staticRenderFns } from "./gifts-voucher.vue?vue&type=template&id=2b0d6b80&"
import script from "./gifts-voucher.vue?vue&type=script&lang=js&"
export * from "./gifts-voucher.vue?vue&type=script&lang=js&"
import style0 from "./gifts-voucher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default})
